import styled, { css } from 'styled-components';

export const FotoAnunciante = styled.div`
    ${(props) =>
        props.hasImage &&
        css`
            border-radius: 50%;
            border: 1px solid gray;
        `}
    position: relative;
    width: 115px;
    height: 80px;
    overflow: hidden;
`;

export const BoxInformacoesAnunciante = styled.div`
    padding: 5% 0;
    display: flex;
`;

export const BoxNomeAnuncianteTexto = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-left: 5%;

    h3 {
        margin: 0 0;
    }

    p {
        padding: 8px 0;
        font-size: large;
        font-weight: bold;
        color: gray;
        margin: 0 0;
    }
`;

export const BoxEnderecoAnunciante = styled.div`
    padding: 0 0 20px;
    text {
        max-width: max-content;
        display: block;
    }
`;
